module.exports = __webpack_public_path__ + "img/finished_icon.53443040.svg";